<template>
  <div class="body">
    <div>
        <div>
          <label class="label-search">Natureza do Risco</label>
          <select v-if="UpAprEdicao === true || aprVisualizacao == true" v-model="formAddRisco.naturezaRisco" class="form-control" :disabled="aprVisualizacao"  @change="handleNaturezaRiscoChange">
              <option :value="null">Selecione</option>
              <option v-for="data in dataCausa" :key="data.id" :value="data.id">{{data.descricao}}</option>
          </select>

          <select v-if="UpAprEdicao === false && aprVisualizacao == false" v-model="formAddRisco.naturezaRisco" class="form-control" :disabled="aprVisualizacao" @change="handleNaturezaRiscoChange">
              <option :value="null">Selecione</option>
              <option v-for="data in dataCausa" :key="data.id" :value="data">{{data.descricao}}</option>
          </select>
        </div>
        <div>
        <div>
            <div style="width: 100%;">
                <label class="label-search margin">Fonte Geradora</label>
                <select v-if="UpAprEdicao === true || aprVisualizacao === true" v-model="formAddRisco.fonteGeradora" class="form-control" :disabled="aprVisualizacao" @change="handleNaturezaRiscoChange">
                    <option :value="null">Selecione</option>
                    <option class="testeOption" v-for="data in dataFonte" :key="data.id" :value="data.id">{{data.descricao}}</option>
                </select>

                <select v-if="UpAprEdicao === false && aprVisualizacao === false" v-model="formAddRisco.fonteGeradora" class="form-control" :disabled="aprVisualizacao" @change="handleNaturezaRiscoChange">
                    <option :value="null">Selecione</option>
                    <option class="testeOption" v-for="data in dataFonte" :key="data.id" :value="data">{{data.descricao}}</option>
                </select>
            </div>
        </div>
        </div>
        <div>
        <div>
            <div style="width: 100%;">
                <label class="label-search margin">Possíveis Consequências</label>

                <b-form-select v-if="UpAprEdicao === true" v-model="formAddRisco.consequecias" class="form-control mb-3" :disabled="aprVisualizacao" @change="handleNaturezaRiscoChange">
                <b-form-select-option :value="null">Selecione</b-form-select-option>
                    <b-form-select-option
                        v-for="option in dataConsequencia"
                        :key="option.id"
                        :value="option.id"
                        v-b-tooltip.hover :title="option.descricao"
                        class="custom-select-option"
                    >
                        {{ option.descricao.length > 40 ? option.descricao.slice(0, 40) + '...' : option.descricao }}
                    </b-form-select-option>
                </b-form-select>

                <div v-if="aprVisualizacao === true" style="width: 100%;">
                    <b-form-textarea disabled rows="3" v-model="ConsequenciaDescricaoVisualizacao"></b-form-textarea>
                </div>

                <b-form-select v-if="UpAprEdicao === false && aprVisualizacao === false" v-model="formAddRisco.consequecias" class="form-control mb-3" :disabled="aprVisualizacao" @change="handleNaturezaRiscoChange">
                <b-form-select-option :value="null">Selecione</b-form-select-option>
                    <b-form-select-option
                        v-for="option in dataConsequencia"
                        :key="option.id"
                        :value="option"
                        v-b-tooltip.hover :title="option.descricao"
                        class="custom-select-option"
                    >
                        {{ option.descricao.length > 40 ? option.descricao.slice(0, 40) + '...' : option.descricao }}
                    </b-form-select-option>
                </b-form-select>
            </div>
        </div>
        <div>

            <div style="max-width: 100%;">
                <label class="label-search margin">Medidas de Controle / Mitigadoras</label>

            <b-form-select @change="handleNaturezaRiscoChange" v-if="UpAprEdicao === true" v-model="formAddRisco.medidasDeControle" class="custom-select mb-3" :disabled="aprVisualizacao">
                <b-form-select-option :value="null">Selecione</b-form-select-option>
                <b-form-select-option
                    v-for="option in dataMedidaControleCompleto"
                    :key="option.id"
                    :value="option.id"
                    v-b-tooltip.hover :title="option.descricao"
                    class="custom-select-option"
                >
                     {{ option.descricao.length > 40 ? option.descricao.slice(0, 40) + '...' : option.descricao }}
                </b-form-select-option>
                </b-form-select>

            <div v-if="aprVisualizacao === true" style="width: 100%;">
                  <b-form-textarea disabled rows="8" v-model="medidaDescricaoVizualizacao"></b-form-textarea>
            </div>

            <b-form-select @change="handleNaturezaRiscoChange" v-if="UpAprEdicao === false && aprVisualizacao === false" v-model="formAddRisco.medidasDeControle" class="custom-select mb-3" :disabled="aprVisualizacao">
                <b-form-select-option :value="null">Selecione</b-form-select-option>
                <b-form-select-option
                    v-for="option in dataMedidaControleCompleto"
                    :key="option.id"
                    :value="option"
                    v-b-tooltip.hover :title="option.descricao"
                    class="custom-select-option"
                >
                        {{ option.descricao.length > 40 ? option.descricao.slice(0, 40) + '...' : option.descricao }}
                </b-form-select-option>
                </b-form-select>
            </div>

        </div>
        <div>
            <div style="width: 100%;">
                <label class="label-search margin">Observações</label>
                <b-form-textarea rows="3" v-model="formAddRisco.observacao" :disabled="aprVisualizacao" placeholder="Observação opcional sobre esse risco"></b-form-textarea>
            </div>
        </div>
        </div>
    </div>

    <div class="d-flex container_cancel_save" v-if="aprVisualizacao === false">
        <div class="cancelar">
            <button class="button-cancel" @click="cancel">CANCELAR</button>
        </div>
        <div class="criar">
            <button class="button-save" @click="Adicionar">{{UpAprEdicao == true ? "Editar" : "Adicionar"}}</button>
        </div>
    </div>
  </div>

</template>

<script>
import addRisk from './addRisk'
export default addRisk
</script>

  <style scoped>
.custom-select .custom-select-option {
  font-weight: normal !important;
  display: block !important;
  min-height: 1.2em !important;
  padding: 0px 2px 1px !important;
  white-space: normal !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  max-width: 200px !important;
  word-wrap: break-word !important;
}

.form-control option >{
    display: flex;
    background-color: aqua;
    widows: 100px !important;
    text-decoration: underline;
}

.selectboxit-container .selectboxit, .selectboxit-container .selectboxit-options {
    width: 400px; /* Width of the dropdown button */
    border-radius:0;
    max-height:100px;
}

.selectboxit-options .selectboxit-option .selectboxit-option-anchor {
    white-space: normal;
    min-height: 30px;
    height: auto;
}

  .label-search{
    font-family: 'Segoe UI';
    font-size: 14px;
    font-weight: bold;
    color: rgb(141, 141, 141);
  }
   .margin {
    margin-top: 1rem;
   }
  .body{
    width: 100%;
    padding: 1rem;
  }
  .nome-epi{
    color: rgb(116, 116, 116);
    font-size: 13px;
    font-family: 'Segoe UI';
  }
 .descricaoArea{
    width: 100%;
    height: 5rem;
    border-color: #b3b3b3;
    border-radius: 1px;
 }

 .container_cancel_save{
  justify-content: center;
  width: 100%;
  margin-top: 1.5rem;
  column-gap: 20px;
 }

 .button-cancel{
   background-color: #b60000;
   color: white;
 }
 .button-save{
  background-color: darkgreen;
  color: white;
 }

.button-cancel,
.button-save{
  margin-top: 10;
  font-size: 12PX;
  outline: transparent;
  border: transparent;
  border-radius: 4px;
  text-transform: uppercase;
  width: 190px;
  height: 40px;
}

</style>



// WEBPACK FOOTER //
// src/views/private/apr/templateApr/components/addRisk/addRisk.vue